import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../../navigators';
import {SuccessTemplate} from '../../../../../components/templates/success';
import {PrimaryButton} from '../../../../../components/buttons';
import {message} from '../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanScheduleSuccess'
>;

const SalesmanScheduleSuccessScreen = ({navigation}: ScreenProps) => {
  const handlePrimaryPress = () => {
    navigation.navigate('SalesmanScheduleList');
  };

  return (
    <SuccessTemplate
      title={message('salesman-schedule-success-title')}
      summary={message('salesman-schedule-success-summary')}>
      <PrimaryButton
        label={message('salesman-schedule-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
    </SuccessTemplate>
  );
};
export default SalesmanScheduleSuccessScreen;
